import tracker from 'app-components/utils/core/tracker';
import store from 'app-components/utils/redux-store';
import type RootState from 'app-components/utils/redux-store/rootState';

import { safeParse } from '../../aiChatUtils';
import { returnToolResponse } from '../llmToolsFramework';
import type { ToolMessage } from '../llmToolsTypes';

export const suggestTools = {
  submit_suggestion: {
    definition: {
      name: 'submit_suggestion',
      description:
        'Call this tool when the user expresses a suggestion or idea about the app (e.g. "I wish the app had X", "it would be great if you could Y"). ' +
        'After calling this tool, tell the user their suggestion has been noted and will be shared with the team.',
      parameters: {
        type: 'object' as const,
        properties: {
          suggestion: {
            type: 'string' as const,
            description: "The user's suggestion or feedback, verbatim or closely paraphrased.",
          },
        },
        required: ['suggestion'],
      },
    },

    handler: (msg: ToolMessage) => {
      const args = safeParse(msg.arguments) || {};
      const { suggestion } = args;

      if (!suggestion) {
        return returnToolResponse(msg, { success: false, error: 'No suggestion provided' });
      }

      tracker.track(tracker.events.AISuggest, {
        suggestion,
        conversationId: (store?.getState() as RootState)?.aiChatStore?.currentConversationId,
      });

      return returnToolResponse(msg, { success: true });
    },
  },
};
